const getCapacity = (c) => {
    return Math.max(c.remainingAttendeeCapacity + Math.max((c.courseInstanceReservations[0]?.amountReserved || 0)
        - (c.courseInstanceReservations[0]?.amountPlanned || 0), 0), 0);
}
export default getCapacity;
